import type { Display, ResultColumn, RunResult } from './types'

/** Culorile si regulile rezultatului, comune graficelor si tabelului. */

export const PALETTE = ['#3b82c4', '#5aa36b', '#e0a43a', '#c2571f', '#7c5bb5', '#2f9e9e', '#a0362a', '#7c8896']

const DERIVED = ['share', 'previous', 'change']

export const RULE_FILL: Record<string, { bg: string; fg: string }> = {
  red: { bg: '#fbe3e1', fg: '#8f2d22' },
  amber: { bg: '#fdf0d8', fg: '#7a4a06' },
  green: { bg: '#e3f3e6', fg: '#1f6a35' },
  blue: { bg: '#e3eefa', fg: '#1f4f86' },
}

/** Masurile care se deseneaza (fara pondere, perioada dinainte, schimbare). */
export function seriesColumns(result: RunResult): ResultColumn[] {
  return result.columns.filter((c) => c.role === 'measure' && !DERIVED.includes(c.agg ?? ''))
}

/** Culoarea ceruta de prima regula potrivita, ca `ReportEmail::ruleColor`. */
export function ruleColor(display: Display | undefined, key: string, value: unknown): string | null {
  if (typeof value !== 'number') return null
  for (const r of display?.rules ?? []) {
    if (r.col !== key) continue
    const hit = r.op === 'gt' ? value > r.value : r.op === 'gte' ? value >= r.value : r.op === 'lt' ? value < r.value : r.op === 'lte' ? value <= r.value : value === r.value
    if (hit) return r.color
  }
  return null
}
